/**
 * Error messages and error page constants
 */

// Server error messages
export const INTERNAL_SERVER_ERROR_TITLE = "Error Code: 500 Internal Server Error";
export const INTERNAL_SERVER_ERROR_DESCRIPTION =
	"We are working to fix the problem. In the meantime please refresh the page or try again in few minutes.";

// Export error messages
export const EXPORT_DOWNLOAD_SERVER_ERROR_TITLE = "Export data not available.";
export const EXPORT_DOWNLOAD_SERVER_ERROR_MESSAGE = "Error Code: 500 Internal Server Error";
export const EXPORT_DOWNLOAD_SERVER_ERROR_DETAILS = "Please contact scrm@costco.com for help.";

// Access control messages
export const ACCESS_DENIED_TITLE = "You are not authorized to access this page";
export const ACCESS_DENIED_DESCRIPTION =
	"If you would like access, please reach out to the Costco Sustainability admin.";

// 404 error messages
export const NOT_FOUND_TITLE_404 = "We weren't able to find";
export const NOT_FOUND_DESCRIPTION_404 = "what you're looking for.";
export const NOT_FOUND_TITLE_404_TWO = "Page Not Found";
